import { useState } from "react";

interface AboutSectionProps {
    title: string;
    text: string;
    showLinks: boolean;
}

export const AboutSection: React.FC<AboutSectionProps> = ({
    title,
    text,
    showLinks,
}) => {
    const [revealLinks, setRevealLinks] = useState(false);

    return (
        <>
            <div className="col-lg-6 pb-4">
                <h2 className="fw-bold text-primary ">{title}</h2>
                <hr className="hr-heading text-primary" />
                <p className="text-white honour-line-break">{text}</p>
                {showLinks ? (
                    <>
                        <p className="honour-line-break">
                            <a
                                href="https://www.port.ac.uk/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Portsmouth University
                            </a>
                        </p>
                        <p className="text-white honour-line-break">
                            <a
                                href="https://researchportal.port.ac.uk/en/persons/kate-whitman-2"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Dr. Kate Whitman
                            </a>
                        </p>
                        <p className="text-white honour-line-break">
                            <a
                                href="https://researchportal.port.ac.uk/en/persons/samantha-parsley"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Professor Samantha Parsley
                            </a>
                        </p>
                        <p className="text-white honour-line-break">
                            <a
                                href="https://researchportal.port.ac.uk/en/persons/joe-cox"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Dr. Joe Cox
                            </a>
                        </p>
                    </>
                ) : (
                    "d-none"
                )}
            </div>
        </>
    );
};
